import { render, staticRenderFns } from "./AlarmStatus.vue?vue&type=template&id=4a6b47be&scoped=true&"
import script from "./AlarmStatus.vue?vue&type=script&lang=js&"
export * from "./AlarmStatus.vue?vue&type=script&lang=js&"
import style0 from "./AlarmStatus.vue?vue&type=style&index=0&id=4a6b47be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b47be",
  null
  
)

export default component.exports